

export default [
  'ReactPerfTool',
  'ChartComponent',
  'FeatureList',
];



/** WEBPACK FOOTER **
 ** ./src/constants/excludedComponents.js
 **/